export const SUBTITLE = 'subtitle';
export const IMAGE = 'image';
export const TEXT = 'text';
export const BULLET_POINT = 'bullet_point';
